import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { Moment } from "moment";
import moment from "moment";
import 'moment-timezone'; // NEW: Add this import
import { LocaleConfig, LocaleService } from "ngx-daterangepicker-material";
import { Console } from 'console';
import { AuthService } from 'src/app/auth/auth.service';
import { Store,select} from '@ngrx/store';
import * as dateActions from "../../../ngrx/act.action";
import { Dropdown } from 'primeng/dropdown';
import { faRefresh, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { Subject, takeUntil } from 'rxjs';

// NEW: Add compact timezone interface
interface CompactTimeZone {
  label: string;
  value: string;
}

@Component({
  selector: 'app-datetime-range-picker',
  templateUrl: './datetime-range-picker.component.html',
  styleUrls: ['./datetime-range-picker.component.scss'],
})
export class DatetimeRangePickerComponent implements OnInit, OnDestroy {
  faRefresh=faRefresh
  faGlobe=faGlobe
  moment = moment;
  calendarLocale: LocaleConfig;
  ranges: any;
  calendarPlaceholder: string;
  selectedRange: any;
  minDate: Moment;
  maxDate: Moment;
  @Input() onlyTimezone=false;
  @Output() dateRange = new EventEmitter<string>();
  @Output() sendTimeZone = new EventEmitter<string>();
  @ViewChild(Dropdown) dropdown: Dropdown;
  calanderStartFromNow = false;
  label: any;
  private pendingExternalTimezone: string | null = null;
  @Input() set externalTimezone(tz:any){
    if (!tz) {
      return;
    }

    // If component is not ready yet, store it
    if (!this.selectedRange) {
      this.pendingExternalTimezone = tz;
      return;
    }

    // Ignore if already selected
    if (this.selectedTimezone === tz) {
      return;
    }

    // Update only local UI
    this.selectedTimezone = tz;
    moment.tz.setDefault(tz);

    this.selectedRange = {
      ...this.selectedRange,
      startDate: this.selectedRange.startDate.clone().tz(tz),
      endDate: this.selectedRange.endDate.clone().tz(tz)
    };

    this.constUpdateRagnges();

    this.cdr.detectChanges();
  }
  @Input() set fromNow(val: boolean) {
    if (val) {
      this.calanderStartFromNow = val;
      this.selectedRange = {
        startDate: moment(),
        endDate: moment().add(15, 'minutes'),
      };
      this.minDate = moment();
      this.maxDate = moment().clone().add(365, 'day');
    }
  }

  // NEW: Add compact timezone properties
  @Output() timezoneChange = new EventEmitter<string>();
  @Input() showTimezone: boolean = false;

  selectedTimezone: string = moment.tz.guess();
  timezones: CompactTimeZone[] = [];
  private destroy$ = new Subject<void>();
  private presetJustClicked = false;
  constructor(
    public authService: AuthService,
    private store: Store,
    private cdr: ChangeDetectorRef, private renderer: Renderer2, private el: ElementRef,
  ) {
    this.calendarLocale = {
      customRangeLabel: 'Pick a date...',
      applyLabel: 'Apply',
      clearLabel: 'Clear',
      format: 'DD/MM/YYYY - HH:mm:ss',
      daysOfWeek: ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa'],
      monthNames: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
      firstDay: 1,
    };
    let now = new Date();
    let start = moment(
      new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0),
    );
    let end = moment(start).add(1, 'days').subtract(1, 'seconds');
    this.ranges = {
      Today: [
        moment().startOf('day'),
        moment().set({ hour: 23, minute: 59, second: 0 }),
      ],
      Yesterday: [
        moment(start).subtract(1, 'days'),
        moment(end).subtract(1, 'days'),
      ],
      'Last 7 Days': [moment(start).subtract(6, 'days'), moment(end)],
      Monthly: [moment(start).subtract(30, 'days'), moment(end)],
      Realtime: [moment().subtract(900, 'seconds'), moment()],
    };
    this.calendarPlaceholder = ' ';
    this.minDate = moment('01/01/2001').utc();
    this.maxDate = moment().clone().add(2, 'day');

    // NEW: Initialize timezones
    this.initializeTimezones();
  }
  ngOnInit() {
    if (this.pendingExternalTimezone) {
      this.externalTimezone = this.pendingExternalTimezone;
      this.pendingExternalTimezone = null;
    }
    this.authService.dateRange$
        .pipe(takeUntil(this.destroy$))
        .subscribe(range => {
            if (!range) {
                return;
            }
            this.applyDateRange(range);
        });
  }
  private customRangeClickHandler = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    const customLabelText = this.calendarLocale.customRangeLabel;

    const li = target?.closest?.('li');
    if (li?.textContent?.trim() === customLabelText) {
      this.label = undefined;
      this.presetJustClicked = false;
    }
  };
  ngAfterViewInit() {
    document.addEventListener('click', this.customRangeClickHandler, true);
  }
  ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
      document.removeEventListener('click', this.customRangeClickHandler, true);
  }

  private applyDateRange(range: any): void {
    // if (this.isSameRange(this.selectedRange, range)) {
    //     return;
    // }
    this.selectedTimezone = range.tz;
    moment.tz.setDefault(this.selectedTimezone);
    this.selectedRange = {
        startDate: range.startDate.clone(),
        endDate: range.endDate.clone(),
        label: range.label
    };
    this.label = range.label;
    this.constUpdateRagnges();
  }
  private isSameRange(current: any, incoming: any): boolean {
    return !!current &&
      current.startDate?.valueOf() === incoming.startDate?.valueOf() &&
      current.endDate?.valueOf() === incoming.endDate?.valueOf() &&
      current.label === incoming.label &&
      this.selectedTimezone === incoming.tz;
  }
  private getNextSaturday() {
    const dayINeed = 6; // for Saturday
    const today = moment().isoWeekday();
    if (today <= dayINeed) {
      return moment().isoWeekday(dayINeed);
    } else {
      return moment().add(1, 'weeks').isoWeekday(dayINeed);
    }
  }

  private getNextSunday() {
    const dayINeed = 7; // for Sunday
    const today = moment().isoWeekday();
    if (today <= dayINeed) {
      return moment().isoWeekday(dayINeed);
    } else {
      return moment().add(1, 'weeks').isoWeekday(dayINeed);
    }
  }

  // choosedDate(event) {
  //   console.log('choosedDate event:', event);
  //   console.log('selectedRange before:', this.selectedRange);
  //   if (!event || (!event.startDate && !event.endDate)) {
  //     // Clear button clicked
  //     // console.log('Clear button clicked');
  //     this.selectedRange = {
  //       startDate: moment.tz(this.selectedTimezone).subtract(15, 'minutes'),
  //       endDate: moment.tz(this.selectedTimezone),
  //       label: 'Realtime',
  //     };
  //     // this.dateRange.emit({...this.selectedRange, tz: this.selectedTimezone});
  //   } else {
  //     // Normal date range selection
  //     // console.log('hello chodesdataa apply', this.selectedTimezone);
  //     let start = moment.tz(this.selectedTimezone).startOf('day');
  //     let end = moment(start).add(1, 'days').subtract(1, 'seconds');
  //     // console.log(start.valueOf(), end.valueOf(), this.label);
  //     this.ranges = this.calanderStartFromNow
  //       ? {
  //           Today: [
  //             moment.tz(this.selectedTimezone).startOf('day'),
  //             moment
  //               .tz(this.selectedTimezone)
  //               .set({ hour: 23, minute: 59, second: 0 }),
  //           ],
  //           'A Week': [
  //             moment.tz(this.selectedTimezone),
  //             moment.tz(this.selectedTimezone).add(7, 'days'),
  //           ],
  //           'A Month': [
  //             moment.tz(this.selectedTimezone),
  //             moment(end).add(30, 'days'),
  //           ],
  //         }
  //       : {
  //           Today: [
  //             moment.tz(this.selectedTimezone).startOf('day'),
  //             moment
  //               .tz(this.selectedTimezone)
  //               .set({ hour: 23, minute: 59, second: 0 }),
  //           ],
  //           Yesterday: [
  //             moment(start).subtract(1, 'days'),
  //             moment(end).subtract(1, 'days'),
  //           ],
  //           'Last 7 Days': [moment(start).subtract(6, 'days'), moment(end)],
  //           Monthly: [moment(start).subtract(30, 'days'), moment(end)],
  //           Realtime: [
  //             moment.tz(this.selectedTimezone).subtract(900, 'seconds'),
  //             moment(),
  //           ],
  //         };
  //     this.selectedRange.label = this.label;
  //     // this.dateRange.emit({...this.selectedRange, tz: this.selectedTimezone});
  //   }
  //   const payload = { ...this.selectedRange, tz: this.selectedTimezone };

  //   // ✅ Always push to authService so ALL consumers stay in sync
  //   this.authService.sendMessage(payload);

  //   // ✅ Still emit for components using (dateRange) output binding
  //   this.dateRange.emit(payload);
  //   // console.log('hello end', {
  //   //   s: this.selectedRange?.startDate.valueOf(),
  //   //   e: this.selectedRange?.endDate?.valueOf(),
  //   // });
  // }
  choosedDate(event: any) {
    console.log('[choosedDate] fired, presetJustClicked=', this.presetJustClicked, 'label=', this.label, 'event=', event);
  // Ignore intermediate/null events fired by ngx-daterangepicker
  if (
      event &&
      event.startDate === null &&
      event.endDate === null &&
      this.selectedRange?.startDate &&
      this.selectedRange?.endDate
  ) {
      return;
  }

  // User actually cleared the picker
  if (
      !this.selectedRange?.startDate ||
      !this.selectedRange?.endDate
  ) {

      this.selectedRange = {
          startDate: moment.tz(this.selectedTimezone).subtract(15, 'minutes'),
          endDate: moment.tz(this.selectedTimezone),
          label: 'Realtime'
      };
      this.label = 'Realtime';
  } else {

      let start = moment.tz(this.selectedTimezone).startOf('day');
      let end = moment(start).add(1, 'days').subtract(1, 'seconds');

      this.ranges = this.calanderStartFromNow
          ? {
              Today: [
                  moment.tz(this.selectedTimezone).startOf('day'),
                  moment.tz(this.selectedTimezone).set({
                      hour: 23,
                      minute: 59,
                      second: 0
                  })
              ],
              'A Week': [
                  moment.tz(this.selectedTimezone),
                  moment.tz(this.selectedTimezone).add(7, 'days')
              ],
              'A Month': [
                  moment.tz(this.selectedTimezone),
                  moment(end).add(30, 'days')
              ]
          }
          : {
              Today: [
                  moment.tz(this.selectedTimezone).startOf('day'),
                  moment.tz(this.selectedTimezone).set({
                      hour: 23,
                      minute: 59,
                      second: 0
                  })
              ],
              Yesterday: [
                  moment(start).subtract(1, 'days'),
                  moment(end).subtract(1, 'days')
              ],
              'Last 7 Days': [
                  moment(start).subtract(6, 'days'),
                  moment(end)
              ],
              Monthly: [
                  moment(start).subtract(30, 'days'),
                  moment(end)
              ],
              Realtime: [
                  moment.tz(this.selectedTimezone).subtract(900, 'seconds'),
                  moment()
              ]
          };
          // KEY FIX: only trust this.label if a preset click JUST set it for this interaction.
          // If no preset was clicked (e.g. "Pick a date..." custom selection), this.label is stale
          if (this.presetJustClicked && this.label) {
             this.selectedRange.label = this.label;
          } else {
             this.selectedRange.label = 'Custom Range';
          }
  }

  const payload = {
      ...this.selectedRange,
      tz: this.selectedTimezone
  };
  const current = this.authService.getCurrentDateRange();
  // if (this.isSameRange(current, payload)) {
  //     return;
  // }

  this.authService.sendMessage(payload);

  this.dateRange.emit(payload);
  // Reset flag and label after every interaction so nothing leaks into the next one
  this.presetJustClicked = false;
  this.label = undefined;
}


  handleRangeClick($event) {
    console.log('[handleRangeClick] fired with', $event, 'presetJustClicked was', this.presetJustClicked);
    this.label = $event?.label;
    this.presetJustClicked = true; // mark that a named preset was clicked
    if ($event?.label == 'Realtime') {
      const startDate = moment.tz(this.selectedTimezone).subtract(900, 'seconds');
      const endDate = moment.tz(this.selectedTimezone);

      // Update immediately so the button/label reflects it right away,
      // instead of waiting for the user to click Apply.
      this.selectedRange = {
        startDate,
        endDate,
        label: 'Realtime'
      };

      this.ranges = {
        ...this.ranges,
        Realtime: [startDate, endDate],
      };

      this.cdr.detectChanges();
      // this.selectedRange = {...this.selectedRange, startDate: moment().subtract(15, 'minutes'), endDate: moment() };
    } else if ($event?.label == 'Today') {
      // while reload when click on today it is not working so i added this and it is working
      const start = moment.tz(this.selectedTimezone).startOf('day'); // 00:00:00
      const end = moment
        .tz(this.selectedTimezone)
        .set({ hour: 23, minute: 59, second: 0 }); // 23:59:00
      // console.log(start, 'hellls,00000 start');
      // console.log(end, 'hellls,00000 end');

      setTimeout(() => {
        this.ranges = {
          ...this.ranges,
          Today: [
            moment.tz(this.selectedTimezone).startOf('day'),
            moment
              .tz(this.selectedTimezone)
              .set({ hour: 23, minute: 59, second: 0 }),
          ],
        };
        // console.log(this.selectedRange, 'this.selectedRange');
        this.cdr.detectChanges();
      }, 0);
    }
  }

  initializeTimezones(): void {
    try {
      const userTimezone = moment.tz.guess();
      this.selectedTimezone = userTimezone;
      this.sendTimeZone.emit(this.selectedTimezone);
      console.log(this.selectedTimezone);
      const currentOffset = moment.tz(userTimezone).utcOffset();
      // console.log(
      //   currentOffset,
      //   userTimezone,
      //   moment.tz(userTimezone).startOf('day').valueOf(),
      //   moment
      //     .tz(userTimezone)
      //     .startOf('day')
      //     .add(99, 'seconds')
      //     .format('HH:mm:ss'),
      // );
      const commonTimezones = moment?.tz?.names()||[
        'UTC',
        'America/New_York',
        'America/Los_Angeles',
        'Europe/London',
        'Europe/Paris',
        'Asia/Tokyo',
        'Asia/Shanghai',
        'Asia/Kolkata',
        'Australia/Sydney',
        'Australia/Melbourne',
      ];

      if (!commonTimezones.includes(userTimezone)) {
        commonTimezones.unshift(userTimezone);
      }
      this.timezones = commonTimezones.map((tz) => {
        const offset = moment.tz(tz).utcOffset();
        const offsetHours = Math.floor(Math.abs(offset) / 60);
        const offsetMinutes = Math.abs(offset) % 60;
        const sign = offset >= 0 ? '+' : '-';
        const offsetStr = `${sign}${String(offsetHours).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`;
        // console.log(offsetHours, offsetMinutes);
        // Create compact label
        const cityName = tz.split('/').pop()?.replace(/_/g, ' ') || tz;

        return {
          label: `${cityName} (${offsetStr})`,
          value: tz,
        };
      });

      moment.tz.setDefault(this.selectedTimezone);
    } catch (error) {
      console.warn('Could not initialize timezones, defaulting to UTC', error);
      this.selectedTimezone = 'UTC';
      this.timezones = [{ label: 'UTC (+00:00)', value: 'UTC' }];
    }
  }

  handleClick($event) {
    $event.stopPropagation();
  }
  loading=false
  handleResetTimeZone($event){
    this.loading=true
    let out=setTimeout(()=>{
      clearTimeout(out)
      this.initializeTimezones();
      this.loading=false;
      this.handleTimezoneChange({value:this.selectedTimezone})
    },1000)
    
  }



  constUpdateRagnges() {
    // console.log('timezon changed....', this.selectedTimezone);
    let now = new Date();
    let start = moment.tz(this.selectedTimezone).startOf('day');
    let end = moment(start).add(1, 'days').subtract(1, 'seconds');
    // console.log(start.valueOf(), end.valueOf());
    this.ranges = {
      Today: [
        moment.tz(this.selectedTimezone).startOf('day'),
        moment
          .tz(this.selectedTimezone)
          .set({ hour: 23, minute: 59, second: 0 }),
      ],
      Yesterday: [
        moment(start).subtract(1, 'days'),
        moment(end).subtract(1, 'days'),
      ],
      'Last 7 Days': [moment(start).subtract(6, 'days'), moment(end)],
      Monthly: [moment(start).subtract(30, 'days'), moment(end)],
      Realtime: [
        moment.tz(this.selectedTimezone).subtract(900, 'seconds'),
        moment(),
      ],
    };
  }

  // NEW: Handle timezone change
  handleTimezoneChange(event: any): void {
    if (!event?.value) {
      return;
    }

    if (!this.selectedRange) {
      return;
    }

    const tz = event.value;

    // // Ignore duplicate selection
    // if (this.selectedTimezone === tz) {
    //   return;
    // }
    this.selectedTimezone = tz;
    moment.tz.setDefault(this.selectedTimezone);
    // this.timezoneChange.emit(this.selectedTimezone);
    // this.constUpdateRagnges();
    // console.log(this.selectedRange?.startDate, "before............");
    this.selectedRange = {
        ...this.selectedRange,
        startDate: this.selectedRange.startDate.clone().tz(this.selectedTimezone),
        endDate: this.selectedRange.endDate.clone().tz(this.selectedTimezone)
    };
    // console.log(this.selectedRange?.startDate, "after............", this.selectedRange?.startDate.valueOf());
    console.log(this.selectedTimezone);
    this.constUpdateRagnges();

    this.timezoneChange.emit(this.selectedTimezone);
     this.sendTimeZone.emit(this.selectedTimezone);
     const updated = {
          ...this.authService.getCurrentDateRange(),
          tz:this.selectedTimezone,
          startDate:this.selectedRange.startDate.clone(),
          endDate:this.selectedRange.endDate.clone(),
          label: this.selectedRange.label
      };
      // const current = this.authService.getCurrentDateRange();
      // if (
      //     current.tz === this.selectedTimezone &&
      //     current.startDate.valueOf() === this.selectedRange.startDate.valueOf() &&
      //     current.endDate.valueOf() === this.selectedRange.endDate.valueOf()
      // ) {
      //     return;
      // }
      this.authService.sendMessage(updated);
    if (this.selectedRange) {//no need to fetch record just on cheanging timezone as this will not change the actual timestamp
      // this.dateRange.emit({
      //   ...this.selectedRange,
      //   timezone: this.selectedTimezone,
      // });
    }
  }

  getTimezoneAbbr(): string {
    return moment.tz(this.selectedTimezone).format('z');
  }

  onDropdownShow($event){
    if (this.dropdown) {
      this.dropdown.filterValue = null;
    }
  }

  // NEW: Get current offset
  getCurrentOffset(): string {
    const offset = moment.tz(this.selectedTimezone).utcOffset();
    const offsetHours = Math.floor(Math.abs(offset) / 60);
    const offsetMinutes = Math.abs(offset) % 60;
    const sign = offset >= 0 ? '+' : '-';
    return `${sign}${String(offsetHours).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`;
  }


    datesUpdated(event) {}

}
